import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useParamsContext } from './ParamsProvider';
import { useNavigate } from 'react-router-dom';
export const ListContext = createContext();
export function useListContext() {
    return useContext(ListContext)
}
const restore_page_key = 'restore_page'
function storePage(page, limit) {
    localStorage.setItem(restore_page_key, JSON.stringify({ page, limit }))
}
function restorePage() {
    let { page, limit } = JSON.parse(localStorage.getItem(restore_page_key) || `{ "page": 1, "limit": 10 }`);
    localStorage.removeItem(restore_page_key)
    return { restored_page: page, restored_limit: limit }
}
const restore_sort_key = 'restore_sort';
function storeSort(sort, order) {
    localStorage.setItem(restore_sort_key, JSON.stringify({ sort, order }));
}
function restoreSort() {
    try {
        const { sort, order } = JSON.parse(localStorage.getItem(restore_sort_key) || `{}`);
        localStorage.removeItem(restore_sort_key);
        return { restored_sort: sort, restored_order: order };
    } catch {
        return {};
    }
}
export function useReloadPreservingListPage() {
    const { page, limit, sort, order } = useListContext() || {};
    const navigate = useNavigate();
    let reload = useCallback(() => {
        if (page && limit) storePage(page, limit);
        if (sort && order !== undefined) storeSort(sort, order);
        navigate(0);
    }, [navigate, page, limit, sort, order]);

    return reload;
}

export function ListProvider({ children, default_filter, default_sort, default_order = false, name, extra, restore_page_key }) {
    let { restored_page, restored_limit } = restorePage();
    const { restored_sort, restored_order } = restoreSort();
    const { flushParams } = useParamsContext();
    const [error, setError] = useState("")
    const [data, setData] = useState([]);
    const [page, setPage] = useState(restored_page);
    const [total_pages, setTotalPages] = useState(0);
    const [cnt, setCnt] = useState(0);
    const [sort, setSort] = useState(restored_sort || default_sort || 'id');
    const [order, setOrder] = useState(restored_order || default_order);
    const [filter, setFilter] = useState(default_filter || {});
    const [loading, setLoading] = useState(false);
    const [totals, setTotals] = useState(undefined);
    const [limit, setLimit] = useState(restored_limit);
    const [tableInfo, setTableInfo] = useState(null);
    useEffect(() => {
        if (data.length == 0 && total_pages > 0 && total_pages < page) {
            setPage(total_pages);
        }
    }, [data, total_pages, page])
    return (
        <ListContext.Provider value={{
            // force_update, forceUpdate,
            data, setData,
            page, setPage,
            total_pages, setTotalPages,
            cnt, setCnt,
            sort, setSort,
            order, setOrder,
            filter, setFilter,
            loading, setLoading,
            error, setError,
            totals, setTotals,
            limit, setLimit,
            tableInfo, setTableInfo,
            extra,
            restore_page_key
        }}>
            {children}
        </ListContext.Provider>
    );
}